import React from 'react';

import styles from './Spinner.module.scss';

const Spinner: React.FC<{ text?: string; global?: boolean }> = (props) => {
  return (
    <div className={`${styles.comp} ui-spinner ${props.global ? styles.fullscreen : ''}`}>
      <i className={'pi pi-spin pi-spinner'} />{' '}
      <span style={{ verticalAlign: 'top' }}>{props.text ? props.text : 'Gegevens laden...'}</span>
    </div>
  );
};

export default Spinner;
